import * as React from "react";
import type { SFC } from "react";
import { ProducerSuppliedFormSection } from "~/components/form/Sections/index";
import { VariableLookupText } from "~/components/form/VariableLookupText";
import { Summary } from "~/components/form/index";
const KubernetesNamespaceFormSectionReadOnly: SFC<{
    namespace: string;
    onChange: (namespace: string) => void;
}> = (props) => {
    const namespace = props.namespace;
    let summary = Summary.default(<span>The Kubernetes context will be set with the namespace configured on the Kubernetes deployment target, or the default namespace if none is specified on the target.</span>);
    if (!!namespace) {
        summary = Summary.summary(<span>
                The Kubernetes context with be set with the namespace <strong>{namespace}</strong>
            </span>);
    }
    return (<ProducerSuppliedFormSection title="Namespace" summary={summary} errorKey="Namespace" help="Specify the namespace of the Kubernetes context">
            <VariableLookupText label="Namespace" value={namespace} placeholder="Deployment Target Namespace" onChange={props.onChange}/>
        </ProducerSuppliedFormSection>);
};
export default KubernetesNamespaceFormSectionReadOnly;
